import { createCodedError } from '~/common/errors/CodedError';
import { EsignatureType } from '~/enums/EsignatureType';
import type { EsignatureIntegrationType } from '~/features/admin/ESignature/types';
import { JsonApiErrorResponse } from '~/redux/api/ApiTypes';
import { testIsAxiosError } from '~/redux/api/utils';
import { esignature } from '~/services/serviceInstances';

type Request = {
  integrationType: EsignatureIntegrationType;
  vendor: EsignatureType;
};

type ServerRequest = {
  data: {
    type: string;
    attributes: {
      type: string;
      vendor: string;
    };
  };
};

export const createEsignatureIntegration = async (
  request: Request,
): Promise<void> => {
  const serverRequest = mapRequest(request);

  try {
    await esignature.post('/integrations', serverRequest);
  } catch (error) {
    if (testIsAxiosError<JsonApiErrorResponse>(error) && error.response) {
      const errorResponse = error.response.data.errors[0];
      throw createCodedError({
        message: errorResponse.detail ?? errorResponse.title,
        statusCode: errorResponse.status,
        title: errorResponse.title,
      });
    }
    throw error;
  }
};

const mapRequest = (request: Request): ServerRequest => {
  return {
    data: {
      type: 'integrations',
      attributes: {
        type: request.integrationType.toUpperCase(),
        vendor: request.vendor.toUpperCase(),
      },
    },
  };
};
